import { defineMessages } from '../define';

export const library = defineMessages(
  {
    // ── Member: song library ──
    'library.title': 'Lög',
    'library.tab_setlists': 'Lagalistar',
    'library.tab_folders': 'Möppur',
    'library.tab_all': 'Öll lög',
    'library.search_placeholder': 'Leita að lagi eða höfundi',
    'library.search_clear': 'Hreinsa leit',
    'library.search_results': { one: '{count} lag fannst', other: '{count} lög fundust' },
    'library.search_none': 'Ekkert fannst fyrir „{q}“',
    'library.search_none_hint': 'Prófaðu annað orð eða hluta af heiti lagsins.',
    'library.search_collections': 'Lagalistar og möppur',
    'library.empty_songs': 'Engin lög enn',
    'library.empty_songs_hint': 'Lögin birtast hér þegar stjórnandinn hefur sett þau inn.',
    'library.empty_setlists': 'Engir lagalistar enn',
    'library.empty_folders': 'Engar möppur enn',
    'library.empty_collections_hint': 'Öll lögin eru undir „Öll lög“.',
    'library.song_count': { one: '{count} lag', other: '{count} lög' },
    'library.kind_sheet': 'Nótur',
    'library.kind_audio': 'Hljóðskrá',
    'library.kind_lyrics': 'Texti',
    'library.kind_unknown': 'Óþekkt tegund',
    'library.arranger_short': 'útsetning: {name}',
    'library.setlist': 'Lagalisti',
    'library.folder': 'Mappa',
    'library.open_first': 'Opna fyrsta lag',
    'library.collection_empty': 'Engin lög á þessum lista',
    'library.collection_empty_hint': 'Ýttu á „Bæta við lögum“ til að setja lög á listann.',
    'library.collection_not_found': 'Listinn fannst ekki',
    'library.position': 'Nr. {n}',
    'library.manage': 'Stjórna lögum',
    'library.edit_list': 'Breyta lista',

    // ── Editor: songs ──
    'library.admin_title': 'Lagasafn',
    'library.admin_tab_songs': 'Lög',
    'library.admin_tab_collections': 'Listar og möppur',
    'library.new_song': 'Nýtt lag',
    'library.create': 'Stofna',
    'library.song_details': 'Upplýsingar um lagið',
    'library.field_title': 'Heiti',
    'library.field_composer': 'Tónskáld',
    'library.field_arranger': 'Útsetjari',
    'library.field_lyricist': 'Textahöfundur',
    'library.field_notes': 'Athugasemdir',
    'library.title_required': 'Sláðu inn heiti',
    'library.revert': 'Afturkalla',
    'library.delete_song': 'Eyða lagi',
    'library.delete_song_confirm': 'Lagið „{title}“ og allar skrár þess verða fjarlægð. Ertu viss?',
    'library.song_deleted': 'Laginu var eytt',
    'library.song_not_found': 'Lagið fannst ekki',
    'library.view_as_member': 'Skoða',

    // ── Editor: files ──
    'library.files': 'Skrár',
    'library.no_files': 'Engar skrár enn',
    'library.no_files_hint': 'Bættu við nótum (PDF), hljóðskrám eða texta hér fyrir neðan.',
    'library.group_sheet': 'Nótur',
    'library.group_audio': 'Hljóðskrár',
    'library.group_lyrics': 'Textar',
    'library.audience': 'Hver sér skrána?',
    'library.audience_required': 'Veldu a.m.k. einn hóp.',
    'library.rename': 'Endurnefna',
    'library.file_title': 'Heiti skrár',
    'library.move_up': 'Færa upp',
    'library.move_down': 'Færa niður',
    'library.replace': 'Skipta út skrá',
    'library.replace_queued': 'Ný útgáfa fer í upphleðslu',
    'library.replace_wrong_kind': 'Veldu skrá af sömu tegund: PDF fyrir nótur, hljóðskrá fyrir hljóð.',
    'library.upload_again': 'Hlaða upp aftur',
    'library.delete_file': 'Eyða skrá',
    'library.delete_file_confirm': 'Eyða „{title}“? Félagar hætta að sjá skrána.',
    'library.file_deleted': 'Skránni var eytt',
    'library.file_incomplete': 'Upphleðslu ekki lokið – félagar sjá skrána ekki',
    'library.file_pages': { one: '{count} síða', other: '{count} síður' },
    'library.file_rev': 'útgáfa {rev}',
    'library.lyrics_lines': { one: '{count} lína', other: '{count} línur' },
    'library.in_queue': 'Í upphleðslu…',
    'library.edit_lyrics': 'Breyta texta',

    // ── Editor: adding files ──
    'library.add_files': 'Bæta við skrám',
    'library.drop_here': 'Dragðu skrár hingað',
    'library.drop_hint': 'Nótur (PDF), hljóðskrár (MP3, M4A, WAV, AAC) og textar (.txt). Velja má margar skrár í einu.',
    'library.choose_files': 'Velja skrár',
    'library.review_title': 'Yfirfarðu skrárnar',
    'library.review_hint': 'Athugaðu heiti og hverjir sjá hverja skrá áður en þú hleður upp.',
    'library.upload_n': { one: 'Hlaða upp {count} skrá', other: 'Hlaða upp {count} skrám' },
    'library.queued': { one: '{count} skrá bætt í biðröð', other: '{count} skrám bætt í biðröð' },
    'library.remove_from_list': 'Fjarlægja',
    'library.unsupported': 'Þessa skráartegund er ekki hægt að nota. Notaðu PDF, MP3, M4A, WAV, AAC eða .txt.',
    'library.unsupported_audio': 'Þetta hljóðsnið er ekki hægt að nota (t.d. AIFF, WMA eða MIDI). Vistaðu upptökuna sem MP3 eða M4A og reyndu aftur.',
    'library.empty_file': 'Skráin er tóm.',
    'library.too_big_audio': 'Skráin er {size} en hámarkið er {max}. Vistaðu hljóðið sem MP3 eða M4A (t.d. 192 kbps) og reyndu aftur.',
    'library.too_big_pdf': 'PDF-skráin er {size} en hámarkið er {max}. Minnkaðu skrána eða skiptu henni í hluta.',
    'library.too_big_text': 'Textinn er of langur.',
    'library.preview': 'Forskoðun',
    'library.read_as': 'lesið sem {enc}',
    'library.show_more': 'Sýna allt',
    'library.show_less': 'Sýna minna',

    // ── Editor: lyrics ──
    'library.add_lyrics': 'Bæta við texta',
    'library.paste_lyrics': 'Límdu texta úr Word/PDF',
    'library.choose_txt': 'Velja .txt-skrá',
    'library.lyrics_title_default': 'Texti',
    'library.lyrics_empty': 'Enginn texti enn',
    'library.lyrics_too_long': 'Textinn má mest vera {max} stafir.',
    'library.lyrics_queued': 'Vista texta…',
    'library.err_read_text': 'Ekki tókst að lesa textaskrána.',

    // ── Editor: upload queue ──
    'library.queue_title': 'Upphleðsla',
    'library.queue_progress': '{done} af {total} lokið',
    'library.queue_failed': { one: '{count} mistókst', other: '{count} mistókust' },
    'library.queue_keep_open': 'Ekki loka glugganum á meðan skrár hlaðast upp.',
    'library.clear_done': 'Hreinsa lokið',
    'library.cancel_upload': 'Hætta við upphleðslu',
    'library.job_queued': 'Bíður',
    'library.job_create': 'Stofna skrá…',
    'library.job_read': 'Les PDF-skrána…',
    'library.job_render': 'Teikna síðu {page} af {pages} ({tier})',
    'library.job_duration': 'Les lengd…',
    'library.job_upload': 'Hleð upp {i} af {n}…',
    'library.job_commit': 'Lýk við…',
    'library.job_done': 'Lokið',
    'library.job_error': 'Mistókst: {reason}',
    'library.job_fix_file': 'Það þýðir ekki að reyna aftur með sömu skrá. Fjarlægðu hana úr biðröðinni, lagaðu skrána og hlaðu henni upp á ný.',
    'library.remove_from_queue': 'Fjarlægja úr biðröðinni',
    'library.err_pdf': 'Ekki tókst að lesa PDF-skrána. Er hún skemmd?',
    'library.err_pdf_decoders': 'Forritið gat ekki opnað myndlesara PDF-skráa (uppsetning appsins er ófullkomin). Hafðu samband við kerfisstjóra.',
    'library.err_pdf_image': 'Mynd í PDF-skránni tókst ekki að lesa – síður hefðu orðið auðar. Prófaðu að vista PDF-skrána aftur úr skannanum.',
    'library.err_pdf_password': 'PDF-skráin er læst með lykilorði. Opnaðu hana og vistaðu án lykilorðs.',
    'library.err_encode': 'Vafrinn gat ekki búið til myndir af síðunum. Prófaðu annan vafra.',
    'library.err_bundle_big': 'Síðumyndirnar urðu of stórar. Skiptu PDF-skránni í styttri hluta.',
    'library.err_too_many_pages': 'PDF-skráin er of löng (mest {max} síður). Skiptu henni í hluta.',

    // ── Editor: setlists & folders ──
    'library.new_setlist': 'Nýr lagalisti',
    'library.new_folder': 'Ný mappa',
    'library.edit_collection': 'Breyta nafni og lýsingu',
    'library.kind': 'Tegund',
    'library.setlist_hint': 'Lög í ákveðinni röð, t.d. fyrir tónleika.',
    'library.folder_hint': 'Safn laga, t.d. „Jólalög“.',
    'library.field_name': 'Nafn',
    'library.field_description': 'Lýsing',
    'library.name_required': 'Sláðu inn nafn',
    'library.delete_collection': 'Eyða lista',
    'library.delete_collection_confirm': 'Eyða „{name}“? Lögin sjálf verða áfram í safninu.',
    'library.collection_deleted': 'Listanum var eytt',
    'library.add_songs': 'Bæta við lögum',
    'library.on_list': 'Á listanum',
    'library.list_full': 'Listinn er fullur (mest {max} lög).',
    'library.on_list_times': { one: '{count} sinni á listanum', other: '{count} sinnum á listanum' },
    'library.remove_entry': 'Taka af lista',
    'library.entry_note': 'Athugasemd',
    'library.entry_note_placeholder': 'Athugasemd, t.d. „byrjum á 2. erindi“',
    'library.drag_handle': 'Dragðu til að færa',
    'library.song_missing': 'Lag ekki lengur til',
    'library.unsaved_changes': 'Óvistaðar breytingar',
    'library.no_changes': 'Engar breytingar',
    'library.save_list': 'Vista lista',
    'library.leave_unsaved': 'Breytingar á listanum hafa ekki verið vistaðar. Fara samt?',
    'library.leave_anyway': 'Fara án þess að vista',
    'library.stay': 'Halda áfram að breyta',
    'library.list_stale': 'Listanum var breytt á meðan og breytingarnar þínar voru ekki vistaðar. Nýjasta útgáfan er sýnd – gerðu þær aftur.',

    // ── Editor: shared order of a list (Raða) ──
    'library.reorder': 'Raða',
    'library.reorder_songs': 'Raða lögum',
    'library.reorder_title': 'Raða lögum á „{name}“',
    'library.reorder_hint': 'Notaðu örvarnar eða veldu sæti. Allir sjá nýju röðina þegar þú vistar.',
    'library.move_up_named': 'Færa „{title}“ upp',
    'library.move_down_named': 'Færa „{title}“ niður',
    'library.move_to': 'Færa í sæti',
    'library.moved_to': '„{title}“ er nú nr. {n} af {count}',
    'library.reorder_save': 'Vista röð',
    'library.reorder_cancel': 'Hætta við',
    'library.reorder_saved': 'Ný röð vistuð – allir sjá hana',
    'library.reorder_discard': 'Henda breytingum á röðinni?',
    'library.reorder_discard_yes': 'Henda breytingum',
    'library.reorder_stale': 'Listanum var breytt á meðan. Nýjasta röðin er sýnd – raðaðu aftur.',
    'library.reorder_offline': 'Nettengingu þarf til að vista röðina',
    'library.reorder_loading': 'Sæki nýjustu röðina…',
  },
  {
    // ── Member: song library ──
    'library.title': 'Songs',
    'library.tab_setlists': 'Setlists',
    'library.tab_folders': 'Folders',
    'library.tab_all': 'All songs',
    'library.search_placeholder': 'Search songs or composers',
    'library.search_clear': 'Clear search',
    'library.search_results': { one: '{count} song found', other: '{count} songs found' },
    'library.search_none': 'Nothing found for “{q}”',
    'library.search_none_hint': 'Try another word or part of the song title.',
    'library.search_collections': 'Setlists and folders',
    'library.empty_songs': 'No songs yet',
    'library.empty_songs_hint': 'Songs appear here once the conductor has added them.',
    'library.empty_setlists': 'No setlists yet',
    'library.empty_folders': 'No folders yet',
    'library.empty_collections_hint': 'All songs are under “All songs”.',
    'library.song_count': { one: '{count} song', other: '{count} songs' },
    'library.kind_sheet': 'Sheet music',
    'library.kind_audio': 'Audio',
    'library.kind_lyrics': 'Lyrics',
    'library.kind_unknown': 'Unknown type',
    'library.arranger_short': 'arr. {name}',
    'library.setlist': 'Setlist',
    'library.folder': 'Folder',
    'library.open_first': 'Open first song',
    'library.collection_empty': 'No songs on this list',
    'library.collection_empty_hint': 'Tap “Add songs” to put songs on the list.',
    'library.collection_not_found': 'List not found',
    'library.position': 'No. {n}',
    'library.manage': 'Manage songs',
    'library.edit_list': 'Edit list',

    // ── Editor: songs ──
    'library.admin_title': 'Song library',
    'library.admin_tab_songs': 'Songs',
    'library.admin_tab_collections': 'Lists & folders',
    'library.new_song': 'New song',
    'library.create': 'Create',
    'library.song_details': 'Song details',
    'library.field_title': 'Title',
    'library.field_composer': 'Composer',
    'library.field_arranger': 'Arranger',
    'library.field_lyricist': 'Lyricist',
    'library.field_notes': 'Notes',
    'library.title_required': 'Enter a title',
    'library.revert': 'Undo changes',
    'library.delete_song': 'Delete song',
    'library.delete_song_confirm': '“{title}” and all its files will be removed. Are you sure?',
    'library.song_deleted': 'Song deleted',
    'library.song_not_found': 'Song not found',
    'library.view_as_member': 'View',

    // ── Editor: files ──
    'library.files': 'Files',
    'library.no_files': 'No files yet',
    'library.no_files_hint': 'Add sheet music (PDF), audio or lyrics below.',
    'library.group_sheet': 'Sheet music',
    'library.group_audio': 'Audio',
    'library.group_lyrics': 'Lyrics',
    'library.audience': 'Who can see it?',
    'library.audience_required': 'Choose at least one group.',
    'library.rename': 'Rename',
    'library.file_title': 'File title',
    'library.move_up': 'Move up',
    'library.move_down': 'Move down',
    'library.replace': 'Replace file',
    'library.replace_queued': 'New version queued for upload',
    'library.replace_wrong_kind': 'Choose a file of the same type: PDF for sheet music, an audio file for audio.',
    'library.upload_again': 'Upload again',
    'library.delete_file': 'Delete file',
    'library.delete_file_confirm': 'Delete “{title}”? Members will no longer see it.',
    'library.file_deleted': 'File deleted',
    'library.file_incomplete': 'Upload not finished – members can’t see this file',
    'library.file_pages': { one: '{count} page', other: '{count} pages' },
    'library.file_rev': 'version {rev}',
    'library.lyrics_lines': { one: '{count} line', other: '{count} lines' },
    'library.in_queue': 'Uploading…',
    'library.edit_lyrics': 'Edit lyrics',

    // ── Editor: adding files ──
    'library.add_files': 'Add files',
    'library.drop_here': 'Drag files here',
    'library.drop_hint': 'Sheet music (PDF), audio (MP3, M4A, WAV, AAC) and lyrics (.txt). You can pick several files at once.',
    'library.choose_files': 'Choose files',
    'library.review_title': 'Check the files',
    'library.review_hint': 'Check the title and who can see each file before uploading.',
    'library.upload_n': { one: 'Upload {count} file', other: 'Upload {count} files' },
    'library.queued': { one: '{count} file queued', other: '{count} files queued' },
    'library.remove_from_list': 'Remove',
    'library.unsupported': 'This file type can’t be used. Use PDF, MP3, M4A, WAV, AAC or .txt.',
    'library.unsupported_audio': 'This audio format can’t be used (e.g. AIFF, WMA or MIDI). Save the recording as MP3 or M4A and try again.',
    'library.empty_file': 'The file is empty.',
    'library.too_big_audio': 'The file is {size}; the limit is {max}. Save the audio as MP3 or M4A (e.g. 192 kbps) and try again.',
    'library.too_big_pdf': 'The PDF is {size}; the limit is {max}. Make it smaller or split it into parts.',
    'library.too_big_text': 'The text is too long.',
    'library.preview': 'Preview',
    'library.read_as': 'read as {enc}',
    'library.show_more': 'Show all',
    'library.show_less': 'Show less',

    // ── Editor: lyrics ──
    'library.add_lyrics': 'Add lyrics',
    'library.paste_lyrics': 'Paste lyrics from Word/PDF',
    'library.choose_txt': 'Choose a .txt file',
    'library.lyrics_title_default': 'Lyrics',
    'library.lyrics_empty': 'No text yet',
    'library.lyrics_too_long': 'Lyrics can be at most {max} characters.',
    'library.lyrics_queued': 'Saving lyrics…',
    'library.err_read_text': 'Could not read the text file.',

    // ── Editor: upload queue ──
    'library.queue_title': 'Uploads',
    'library.queue_progress': '{done} of {total} done',
    'library.queue_failed': { one: '{count} failed', other: '{count} failed' },
    'library.queue_keep_open': 'Don’t close this window while files are uploading.',
    'library.clear_done': 'Clear finished',
    'library.cancel_upload': 'Cancel upload',
    'library.job_queued': 'Waiting',
    'library.job_create': 'Creating file…',
    'library.job_read': 'Reading the PDF…',
    'library.job_render': 'Rendering page {page} of {pages} ({tier})',
    'library.job_duration': 'Reading length…',
    'library.job_upload': 'Uploading {i} of {n}…',
    'library.job_commit': 'Finishing…',
    'library.job_done': 'Done',
    'library.job_error': 'Failed: {reason}',
    'library.job_fix_file': 'Trying again with the same file won’t help. Remove it from the queue, fix the file and upload it again.',
    'library.remove_from_queue': 'Remove from the queue',
    'library.err_pdf': 'Could not read the PDF. Is it damaged?',
    'library.err_pdf_decoders': "The app could not load its PDF image decoders (the installation is incomplete). Contact the administrator.",
    'library.err_pdf_image': 'An image in the PDF could not be decoded – pages would have been blank. Try exporting the PDF again from the scanner.',
    'library.err_pdf_password': 'The PDF is password protected. Open it and save it without a password.',
    'library.err_encode': 'The browser could not create page images. Try another browser.',
    'library.err_bundle_big': 'The page images got too large. Split the PDF into shorter parts.',
    'library.err_too_many_pages': 'The PDF is too long (at most {max} pages). Split it into parts.',

    // ── Editor: setlists & folders ──
    'library.new_setlist': 'New setlist',
    'library.new_folder': 'New folder',
    'library.edit_collection': 'Edit name and description',
    'library.kind': 'Type',
    'library.setlist_hint': 'Songs in a set order, e.g. for a concert.',
    'library.folder_hint': 'A group of songs, e.g. “Christmas songs”.',
    'library.field_name': 'Name',
    'library.field_description': 'Description',
    'library.name_required': 'Enter a name',
    'library.delete_collection': 'Delete list',
    'library.delete_collection_confirm': 'Delete “{name}”? The songs themselves stay in the library.',
    'library.collection_deleted': 'List deleted',
    'library.add_songs': 'Add songs',
    'library.on_list': 'On the list',
    'library.list_full': 'The list is full (at most {max} songs).',
    'library.on_list_times': { one: 'On the list {count} time', other: 'On the list {count} times' },
    'library.remove_entry': 'Remove from list',
    'library.entry_note': 'Note',
    'library.entry_note_placeholder': 'Note, e.g. “start at verse 2”',
    'library.drag_handle': 'Drag to move',
    'library.song_missing': 'Song no longer exists',
    'library.unsaved_changes': 'Unsaved changes',
    'library.no_changes': 'No changes',
    'library.save_list': 'Save list',
    'library.leave_unsaved': 'Changes to the list have not been saved. Leave anyway?',
    'library.leave_anyway': 'Leave without saving',
    'library.stay': 'Keep editing',
    'library.list_stale': 'The list was changed meanwhile and your changes were not saved. The latest version is shown – make them again.',

    // ── Editor: shared order of a list (Reorder) ──
    'library.reorder': 'Reorder',
    'library.reorder_songs': 'Reorder songs',
    'library.reorder_title': 'Reorder songs in “{name}”',
    'library.reorder_hint': 'Use the arrows or pick a place. Everyone sees the new order once you save.',
    'library.move_up_named': 'Move “{title}” up',
    'library.move_down_named': 'Move “{title}” down',
    'library.move_to': 'Move to place',
    'library.moved_to': '“{title}” is now no. {n} of {count}',
    'library.reorder_save': 'Save order',
    'library.reorder_cancel': 'Cancel',
    'library.reorder_saved': 'New order saved – everyone sees it',
    'library.reorder_discard': 'Discard the order changes?',
    'library.reorder_discard_yes': 'Discard changes',
    'library.reorder_stale': 'The list was changed meanwhile. The latest order is shown – reorder again.',
    'library.reorder_offline': 'A connection is needed to save the order',
    'library.reorder_loading': 'Fetching the latest order…',
  },
);
